import React from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { builderSelectedOptionsSelector } from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import {
  MetricTypeKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import SignificanceMeasureMetric from './SignificanceMeasureMetric';
import SignificanceFunnelMetric from './SignificanceFunnelMetric/SignificanceFunnelMetric';
import SignificanceQueryMetric from './SignificanceQueryMetric';
import SignificanceRetentionMetric from './SignificanceRetentionMetric';
import { UnreachableCaseError } from 'ts-essentials';

// Component will render components based on selected metric type
const SignificanceMetricController = () => {
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(selectedOptions?.type === QueryType.Significance);

  const { metric } = selectedOptions;

  switch (metric) {
    case MetricTypeKey.Measure: {
      return <SignificanceMeasureMetric />;
    }
    case MetricTypeKey.Query: {
      return <SignificanceQueryMetric />;
    }
    case MetricTypeKey.Funnel: {
      return <SignificanceFunnelMetric />;
    }
    case MetricTypeKey.Retention: {
      return <SignificanceRetentionMetric />;
    }
    default:
      throw new UnreachableCaseError(metric);
  }
};

export default SignificanceMetricController;
